// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"style-module--arrowButton--35rfM","arrowIcon":"style-module--arrowIcon--1inBc","prev":"style-module--prev--3g9--"};